module.exports = __webpack_public_path__ + "static/img/laravel.b0ba6d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/laravel.png
// module id = EuL8
// module chunks = 1